/**
 * The merchant (ADR 0016): the one who turns loot into gold, at the stall of
 * every village. He only buys for now; selling comes with the shop.
 */
/** The monster that keeps the stall (`data/mobs.ts`). */
export const MERCHANT_MOB_ID = 'merchant';
/** How close to a merchant a player must stand, in tiles, diagonals included. */
export const MERCHANT_REACH = 2;
/**
 * What the merchant sells costs this many times what he pays for it: buying
 * back what one just sold always loses gold.
 */
export const MERCHANT_MARKUP = 4;
/**
 * The supplies every merchant keeps, whatever the village, beside the common
 * pieces of his biome (`merchantStock`). Never the smith's materials: those
 * are hunted, or the smith would be a shop.
 */
export const MERCHANT_SUPPLIES = ['potion-small', 'potion-medium', 'bread'];
//# sourceMappingURL=merchant.js.map